<ng-container>
  <section class="main-section">
    <!-- header section -->
    <div class="main-header-section">
      <div class="header-left">
        <!-- Tabs -->
        <div class="header-tabs">
          <div class="tab" *ngFor="let item of activityCategory" (click)="selectCategory(item)"
            [ngClass]="item.status ? 'activeCategory' : ''">
            {{ item.viewValue }}
          </div>
        </div>

        <!-- Search -->
        <div class="header-search">
          <mat-form-field class="sfull-width domain-input mat-form-field" appearance="outline">
            <mat-icon matPrefix>search</mat-icon>

            <!-- Product Search -->
            <input *ngIf="selectedlist === 'ITEMS'" class="inputStyle" matInput [placeholder]="getPlaceholder()"
              [(ngModel)]="searchText" (keyup)="onSearchChange('ITEMS')" />

            <!-- Category Search -->
            <input *ngIf="selectedlist === 'CATEGORIES'" class="inputStyle" matInput [placeholder]="getPlaceholder()"
              [(ngModel)]="searchCategoriesText" (keyup)="onSearchChange('CATEGORIES')" />

            <!-- Collection Search -->
            <input *ngIf="selectedlist === 'COLLECTIONS'" class="inputStyle" matInput [placeholder]="getPlaceholder()"
              [(ngModel)]="searchCollectionText" (keyup)="onSearchChange('COLLECTIONS')" />
          </mat-form-field>

        </div>
      </div>


      <div class="header-right">
        <!-- Action buttons -->
        <div class="header-actions">

          <button class="btn export-btn" (click)="exportProducts()">Export</button>
          <!-- Export Modal -->
          <div class="modal fade" id="exportModal" tabindex="-1" aria-labelledby="exportModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="exportModalLabel">Export Products</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body text-center">
                  Upload
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary" (click)="exportProducts()">Save changes</button>
                </div>
              </div>
            </div>
          </div>
          <button class="btn import-btn" (click)="importProducts()">Import</button>

          <ng-container *ngIf="selectedlist === 'ITEMS'">
            <button class="btn add-btn" (click)="createProduct()">+ Add New Product</button>
          </ng-container>
          <ng-container *ngIf="selectedlist === 'CATEGORIES'">
            <button class="btn add-btn" (click)="addCategories()">+ Add New Category</button>
          </ng-container>
          <ng-container *ngIf="selectedlist === 'COLLECTIONS'">
            <button class="btn add-btn" (click)="createCollection()">+ Add New Collection</button>
          </ng-container>
        </div>

        <!-- Total count -->
        <div class="total-count">
          Total items: {{ totalCount }}
        </div>
      </div>
    </div>


    <!-- <div class="filter-section" *ngIf="isFilterAvailable">
            <div class="filter-chips">
                <div *ngFor="let item of filteringObject | keyvalue; let i = index">
                    <div class="chips" *ngIf="item.value">
                        <div class="filter-name">{{ item?.value.split("_").join(" ") | titlecase }}</div>
                        <img src="./../../../../../../assets/images/common/close-img.svg" class="close-img"
                            (click)="removeChip(item,i)" />
                    </div>
                </div>
            </div>
            <div class="reset-filter">
                <span class="reset-btn" (click)="resetFilters()">Reset Filters</span>
            </div>
        </div> -->

    <!-- table section -->
    <ng-container *ngIf="!pageLoader; else loadScreen">
      <ng-container *ngIf="screenWidth > 475">
        <ng-container *ngIf="
          dataSource && dataSource.length > 0 && viewAccess;
          else emptyscreen
        ">
          <div class="table-section " style="height: 500px; overflow: auto;" infiniteScroll [infiniteScrollDistance]="1"
            [infiniteScrollThrottle]="200" [scrollWindow]="false" (scrolled)="loadMoreStates()">
            <table mat-table [dataSource]="dataSource | paginate : config" class="mat-elevation-z8">
              <ng-container matColumnDef="productImage">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element; let i = index" style="width:90px">
                  <div (click)="editProduct(element)" style="cursor: pointer;">

                    <img *ngIf="element.itemImages?.[0]?.imgUrl" [src]="element.itemImages[0]?.imgUrl" class="width-50"
                      alt="User uploaded image" />
                    <img *ngIf="!element.itemImages?.[0]?.imgUrl"
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT5GLRiruBbo9dQ85FU7cY9Mt9LCQvridJJV5472zMbU0ZzX6jNUPnnh3J5_UShU-2lWhg&usqp=CAU"
                      class="width-50" alt="Default image" />
                  </div>

                </td>
              </ng-container>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>Product Name</th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <div class="name-section">
                    <div class="name">
                      <div class="nameStyling" style="cursor: pointer;" (click)="editProduct(element)">
                        {{ element?.name | titlecase }}
                      </div>
                    </div>
                    <div class="id">{{ element?.itemType }}</div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="contactNumber">
                <th mat-header-cell *matHeaderCellDef class="headingStyles">
                  Qty
                </th>
                <td mat-cell *matCellDef="let element" class="companyName">
                  {{
                  element?.itemInventory?.openingStock
                  ? element?.itemInventory?.openingStock
                  : "0"
                  }}
                  {{ element?.unit?.key }}
                </td>
              </ng-container>

              <ng-container matColumnDef="sellingPrice">
                <th mat-header-cell *matHeaderCellDef class="headingStyles">
                  SellingPrice
                </th>
                <td mat-cell *matCellDef="let element" class="companyName">
                  <div class="name">
                    <div class="nameStyling">
                      ₹
                      {{
                      element?.price?.sellingPrice
                      ? element?.price?.sellingPrice
                      : "0"
                      }}
                    </div>
                    <!-- <div class="id">5% excl. tax</div> -->
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="maturityAmount">
                <th mat-header-cell *matHeaderCellDef class="headingStyles">
                  Purchase Price
                </th>
                <td mat-cell *matCellDef="let element" class="companyName">
                  <div class="name">
                    <div class="nameStyling">
                      ₹
                      {{
                      element?.price?.purchasePrice
                      ? element?.price?.purchasePrice
                      : "0"
                      }}
                    </div>
                    <!-- <div class="id">
                      {{ element?.price?.taxRef?.taxPercent }}% tax
                    </div> -->
                  </div>
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container>
                <ng-container matColumnDef="installment">
                  <th mat-header-cell *matHeaderCellDef class="headingStyles">
                    Created by
                  </th>
                  <td mat-cell *matCellDef="let element" class="dataColor">
                    {{ element.createdByName ? ( element.createdByName) : 'N/A' }}
                  </td>
                </ng-container>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="Action">
                <th mat-header-cell *matHeaderCellDef class="headingStyles" style="text-align: center">
                  Action
                </th>
                <td mat-cell *matCellDef="let element; index as i" class="actions">
                  <div class="action-section">
                    <!-- <div class="payment-record">
                                <img class="payment-icon"
                                    src="../../../../../assets/images/product/product_barcode.svg">
                            </div> -->
                    <div class="view-section" (click)="editProduct(element)">
                      <img src="../../../assets/images/master/edit-icon.svg" alt="action-icon" class="action-icon" />
                      <span class="view-text">Edit</span>
                    </div>
                    <div class="more-option-section" (click)="deleteProduct(element.itemId)">
                      <img src="../../../assets/images/master/delete-icon.svg" alt="" />
                    </div>

                    <!-- <div class="more-option-section">
                                <img src="../../../../../assets/images/invoice/invoice_more_options.svg" alt="">
                            </div> -->
                  </div>
                </td>
              </ng-container>

              <ng-container *ngIf="screenWidth > 475">
                <ng-container matColumnDef="Category">
                  <th mat-header-cell *matHeaderCellDef class="headingStyles">
                    Category
                  </th>
                  <td mat-cell *matCellDef="let element" class="dataColor">
                    <div class="categorie-section">
                      <div class="categorie-name">
                        {{ element?.categoryName }}
                      </div>
                      <div class="see-product" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight"
                        aria-controls="offcanvasRight" (click)="getProductListByCategorie(element)">
                        + See Products
                      </div>
                    </div>
                  </td>
                </ng-container>
              </ng-container>

              <ng-container>
                <ng-container matColumnDef="description">
                  <th mat-header-cell *matHeaderCellDef class="headingStyles">
                    Description
                  </th>
                  <td mat-cell *matCellDef="let element" class="dataColor">
                    {{ element?.description ? element?.description : "N/A" }}
                  </td>
                </ng-container>
              </ng-container>

              <!-- Action Column -->
              <ng-container matColumnDef="Status">
                <th mat-header-cell *matHeaderCellDef class="headingStyles" style="text-align: center">
                  Action
                </th>
                <td mat-cell *matCellDef="let element; index as i" class="actions">
                  <div class="action-section">
                    <div class="view-section" (click)="editCategories(element)">
                      <img src="../../../assets/images/master/edit-icon.svg" alt="action-icon" class="action-icon" />
                      <span class="view-text">Edit</span>
                    </div>

                    <div class="more-option-section" (click)="deleteCategories(element.categoryId)">
                      <img src="../../../assets/images/master/delete-icon.svg" alt="" />
                    </div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="Collection">
                <th mat-header-cell *matHeaderCellDef class="headingStyles">
                  Collection
                </th>
                <td mat-cell *matCellDef="let element" class="dataColor">
                  <div class="categorie-section">
                    <div class="categorie-name">
                      {{ element?.collectionName }}
                    </div>
                    <!-- <div class="see-product" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight"
                                aria-controls="offcanvasRight" (click)="getProductListByCategorie(element)">
                                + See Products
                              </div> -->
                  </div>
                </td>
              </ng-container>
              <ng-container>
                <ng-container matColumnDef="collectionDescription">
                  <th mat-header-cell *matHeaderCellDef class="headingStyles">
                    Description
                  </th>
                  <td mat-cell *matCellDef="let element" class="dataColor">
                    {{ element?.description ? element?.description : "N/A" }}
                  </td>
                </ng-container>
              </ng-container>
              <ng-container matColumnDef="collectionStatus">
                <th mat-header-cell *matHeaderCellDef class="headingStyles" style="text-align: center">
                  Action
                </th>
                <td mat-cell *matCellDef="let element; index as i" class="actions">
                  <div class="action-section">
                    <div class="view-section" (click)="editCollection(element)">
                      <img src="../../../assets/images/master/edit-icon.svg" alt="action-icon" class="action-icon" />
                      <span class="view-text">Edit</span>
                    </div>

                    <div class="more-option-section" (click)="deleteCollection(element.collectionId)">
                      <img src="../../../assets/images/master/delete-icon.svg" alt="" />
                    </div>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>


          <!-- <div class="pagination-container">
            <pagination-template #p="paginationApi" [id]="id" (pageChange)="pageChanged($event)">
              <div class="custom-pagination"> -->

          <!-- Previous Button -->
          <!-- <div class="pagination-previous" [style.opacity]="pageNo === 0 ? '0.4' : '1'">
                  <a (click)="previousClicked()">
                    <img src="./../../../../../assets/images/common/previous_button.svg" alt="Previous">
                  </a>
                </div> -->


          <!-- Page Numbers -->
          <!-- <div class="pagination-numbers">
                  <div *ngFor="let page of p.pages" [class.current]="pageNo + 1 === page.value"
                    class="pagination-inactive" style="cursor:pointer">
                    <a (click)="pageChanged(page.value)" *ngIf="pageNo + 1 !== page.value"style="text-decoration: none; color: inherit;">
                      <span class="pagination_number">{{ page.label }}</span>
                    </a>
                    <div *ngIf="pageNo + 1 === page.value">
                      <span class="pagination_number">{{ page.label }}</span>
                    </div>
                  </div> -->

          <!-- </div> -->


          <!-- Next Button -->
          <!-- <div class="pagination-next" [style.opacity]="(pageNo + 1) >= mathCount ? '0.4' : '1'">
                  <a (click)="nextClicked()">
                    <img src="./../../../../../assets/images/common/next_pagination.svg" alt="Next">
                  </a>
                </div> -->

          <!-- </div>
            </pagination-template>
          </div> -->

        </ng-container>
      </ng-container>
    </ng-container>

  </section>
</ng-container>

<div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
  <div class="offcanvas-header" style="align-items: unset">
    <h5 id="offcanvasRightLabel" style="font-size: 22px">Product List</h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <ng-container *ngIf="itemDataSource; else emptyscreen">
      <div class="table-section">
        <table mat-table [dataSource]="itemDataSource" class="mat-elevation-z8">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Item Name</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <div class="name-section">
                <div class="name">
                  <div class="nameStyling">
                    {{ element?.itemName | titlecase }}
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="contactNumber">
            <th mat-header-cell *matHeaderCellDef class="headingStyles">Qty</th>
            <td mat-cell *matCellDef="let element" class="companyName">100</td>
          </ng-container>

          <ng-container matColumnDef="sellingPrice">
            <th mat-header-cell *matHeaderCellDef class="headingStyles">
              SellingPrice
            </th>
            <td mat-cell *matCellDef="let element" class="companyName">
              <div class="name">
                <div class="nameStyling">
                  ₹
                  {{
                  element?.price?.sellingPrice
                  ? element?.price?.sellingPrice
                  : "N/A"
                  }}
                </div>
                <!-- <div class="id">5% excl. tax</div> -->
              </div>
            </td>
          </ng-container>

          <ng-container>
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef class="headingStyles">
                Purchase Price
              </th>
              <td mat-cell *matCellDef="let element" class="dataColor">
                {{
                element?.price.purchasePrice
                ? element?.price.purchasePrice
                : "N/A"
                }}
              </td>
            </ng-container>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="itemsdisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: itemsdisplayedColumns"></tr>
        </table>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #emptyscreen>
  <div class="empty-part" *ngIf="viewAccess">
    <img src="../../../../../assets/images/empty_table.svg" alt="" />
    <div class="text" *ngIf="selectedlist === 'ITEMS'">
      No items are added to this Product
    </div>
    <div class="text" *ngIf="selectedlist === 'CATEGORIES'">
      No items are added to this category
    </div>
    <div class="text" *ngIf="selectedlist === 'COLLECTIONS'">
      No items are added to this collection
    </div>
  </div>
  <div *ngIf="!viewAccess" class="not-access-text">
    You don't have view access
  </div>
</ng-template>

<ng-template #loadScreen>
  <section class="loader_section">
    <div class="api_loader">
      <!-- <app-anime-loader></app-anime-loader> -->
      <div class="img-section">
        <!-- <img src="../../../assets/images/loader/beeos_loader.gif" alt="loader.svg" /> -->
        <app-global-lottie-loader></app-global-lottie-loader>
      </div>
    </div>
  </section>
</ng-template>